const lang = {
  relation: {
    title: 'You are linking %{shop} to PingPong Checkout',
    logged: 'Confirm to continue with the following account',
    login: 'Please login your PingPong Checkout account first',
    continue: 'Continue',
    changeAccount: 'Use another account'
  },
  selectWebsite: {
    tipTitle: 'Please select the website you want to connect with',
    tipSubtitle: "We've filtered available website for you",
    otherTipNo1: 'You hereby allow %{shop} to view your following data. This will include:',
    otherTipNo2: '· PingPong Checkout Know Your Customer data (including but not limited to company information, director information and register information)',
    otherTipNo3: '· PingPong Checkout website data (including but not limited to account ID, website, URL and status of website).',
    howToApplyHalf1: 'By clicking “Agree and connect”, you agree to share your above data between %{shop} and PingPong in accordance in',
    symbolAnd: 'and',
    shopifyRule: '%{shop}’s Privacy Policy',
    pingPongRule: 'PingPong Privacy Policy. ',
    sureButton: 'Agree and connect',
    cancelButton: 'Cancel',
    noTokenTip: 'You have no token from %{shop}, please fetch your token and retry.',
    userWantsThisUrl: 'Website: ',
    userWantsThisAccId: 'Acc ID: ',
    accIdBinded: 'has already been connected to another %{shop} account. Once switching your Shopify account，you can only request transactions（e.g: refund） on PingPong Checkout. If you need to change, please click "Continue".',
    webBinded: 'Current %{shop} account has already been connected to another website. Once switching your website，you can only request transactions（e.g: refund） on PingPong Checkout. If you need to change, please click "Continue".',
    accIdGatewayBinded: 'has already been connected to another %{shop} account.',
    webGatewayBinded: 'Current %{shop} account has already been connected to another website.',
    loadingTip: 'doing...',
    attention: 'Attention'
  },
  hasNone: {
    tips: "You don't have any website yet, please add one first.",
    sureButton: 'Add a website',
    cancelButton: 'Cancel'
  },
  loading: {
    doing: 'Loading...',
    success: 'Success',
    successTip1: "You're now leaving PingPong Checkout...",
    successTip2: "You're now leaving PingPong Checkout...",
    failed: 'Failed',
    failedTip1: 'Network Error',
    failedTip2: 'Retry'
  },
  selectRegion: {
    tipSubtitle: 'Please select the region/country of your entity',
    tip: 'If your business entity is not based in the United States, please do not select the US',
    sureButton: 'Confirm',
    cancelButton: 'Cancel',
  }
}

export default lang
